import type { IglooBrickType215, IglooBrickWallet215, IglooProgress215 } from './models';

export type IglooZoneId215 = 'foundation' | 'first-home' | 'living' | 'family' | 'knowledge' | 'landmark';

export interface IglooStage215 {
  stage: number;
  name: string;
  zoneId: IglooZoneId215;
  requirement: number;
  message: string;
  featureId?: string;
  featureLabel?: string;
}

export const iglooZones215 = [
  { id:'foundation' as const, range:'1–6', title:'기초 쉼터', emotion:'시작과 안전' },
  { id:'first-home' as const, range:'7–12', title:'나의 첫 이글루', emotion:'소유와 첫 성장' },
  { id:'living' as const, range:'13–18', title:'생활 공간 확장', emotion:'편안함과 애착' },
  { id:'family' as const, range:'19–24', title:'가족 탐험 이글루', emotion:'협력과 연결' },
  { id:'knowledge' as const, range:'25–30', title:'지식 전시 이글루', emotion:'학습과 성취' },
  { id:'landmark' as const, range:'31–36', title:'스노우빌리지 랜드마크', emotion:'자부심과 완성' },
] as const;

const stageRows: Array<[string, IglooZoneId215, number, string, string?, string?]> = [
  ['눈터 선택','foundation',0,'내가 성장시킬 자리를 골랐어요.'],
  ['바닥 기초','foundation',2,'작은 선택이 단단한 바닥이 되었어요.'],
  ['낮은 외벽','foundation',5,'매일의 행동이 첫 벽을 만들었어요.'],
  ['입구 만들기','foundation',8,'나만의 공간으로 들어가는 길이 열렸어요.'],
  ['지붕 연결','foundation',12,'꾸준함이 둥근 지붕을 이어 주었어요.'],
  ['작은 쉼터 완성','foundation',15,'첫 번째 안전한 쉼터가 완성됐어요.','basic-storage','기본 보관함'],
  ['창문 틀','first-home',20,'세상을 바라보는 작은 창을 준비했어요.'],
  ['창문 완성','first-home',26,'빛이 들어오는 창문이 완성됐어요.','window','창문'],
  ['내부 바닥','first-home',33,'머물고 싶은 내부 공간이 생겼어요.'],
  ['문 장식','first-home',41,'나의 취향이 입구에 드러나기 시작했어요.'],
  ['조명 설치','first-home',50,'어두운 시간에도 따뜻한 빛이 켜져요.','lighting','실내 조명'],
  ['첫 이글루 완성','first-home',60,'나만의 첫 이글루가 완성됐어요.','badge-shelf','배지 선반과 개인 깃발'],
  ['공간 확장 1','living',72,'생활 공간이 한 칸 더 넓어졌어요.'],
  ['공간 확장 2','living',85,'새로운 활동을 담을 여유가 생겼어요.'],
  ['난방 장치','living',99,'추운 날에도 편안한 온기를 지킬 수 있어요.','heating','난방 장치'],
  ['가구 설치','living',114,'기록하고 쉬는 가구가 놓였어요.','furniture','가구 배치'],
  ['작은 마당','living',130,'이글루 밖에도 나만의 마당이 생겼어요.'],
  ['휴식 테라스','living',147,'한 달의 성장을 돌아보는 자리가 열렸어요.','fridge','냥장고와 휴식 테라스'],
  ['가족 입구','family',165,'가족 탐험대가 함께 들어올 문이 열렸어요.'],
  ['가족 메시지 보드','family',184,'서로의 응원을 남길 공간이 생겼어요.','family-board','가족 메시지 보드'],
  ['가족 휴게실','family',204,'함께 대화하고 쉬는 공간이 넓어졌어요.'],
  ['탐험 준비실','family',225,'가족 미션을 준비할 장비가 모였어요.','expedition-room','탐험 준비실'],
  ['캠프파이어 마당','family',247,'따뜻한 불빛 곁에서 돈 이야기를 나눠요.','campfire','캠프파이어 마당'],
  ['가족 이글루 완성','family',270,'혼자 시작한 성장이 가족의 공간이 되었어요.','family-missions','가족 공동 미션'],
  ['책장 설치','knowledge',294,'배운 경제 개념을 꽂아 둘 책장이 생겼어요.'],
  ['연구 책상','knowledge',319,'질문하고 기록하는 연구 공간이 열렸어요.'],
  ['퍼즐 전시 갤러리','knowledge',345,'완성한 퍼즐 이야기를 전시할 수 있어요.','puzzle-gallery','퍼즐 갤러리'],
  ['지식 보관소','knowledge',372,'수료증과 기억 카드를 안전하게 보관해요.','knowledge-vault','지식 보관소'],
  ['교육 돔','knowledge',400,'배운 내용을 가족과 함께 나눌 수 있어요.'],
  ['지식 이글루 완성','knowledge',429,'학습과 성취가 하나의 전시 공간이 되었어요.','certificate-hall','수료증 전시와 경제도서관 연결'],
  ['랜드마크 기단','landmark',459,'마을을 대표할 랜드마크의 기초를 세웠어요.'],
  ['깃발 게양대','landmark',490,'우리 가족 탐험대의 깃발이 높이 올라가요.','landmark-flag','랜드마크 깃발'],
  ['스노우 타워','landmark',522,'멀리서도 보이는 스노우 타워가 세워졌어요.'],
  ['빛의 분수','landmark',555,'쌓아 온 선택이 마을의 빛으로 퍼져 나가요.','light-fountain','빛의 분수'],
  ['마을 광장','landmark',589,'모든 성장 기록이 만나는 광장이 열렸어요.','village-square','마을 광장'],
  ['스노우빌리지 랜드마크','landmark',624,'오랜 선택과 실천이 마을의 상징으로 완성됐어요.','village-panorama','마을 전경과 연간 명예 기록'],
];

export const iglooStages215: IglooStage215[] = stageRows.map(([name,zoneId,requirement,message,featureId,featureLabel], index) => ({
  stage:index+1, name, zoneId, requirement, message, ...(featureId?{featureId,featureLabel}:{}),
}));

export const iglooStageRequirements = iglooStages215.map((item)=>item.requirement);

export function emptyBrickWallet215(): IglooBrickWallet215 {
  return { ice:0, family:0, knowledge:0, sharing:0, challenge:0 };
}

export function brickWalletTotal215(wallet: IglooBrickWallet215): number {
  return Object.values(wallet).reduce((sum,value)=>sum+Math.max(0,Number(value)||0),0);
}

export function iglooStageForBricks(totalBricks: number): number {
  let stage=1;
  for (const item of iglooStages215) if (totalBricks>=item.requirement) stage=item.stage;
  return Math.min(36,stage);
}

export function nextIglooRequirement(stage: number): number {
  return iglooStages215[Math.min(Math.max(1,stage),36)]?.requirement ?? iglooStages215.at(-1)!.requirement;
}

export function unlockedFeaturesForStage215(stage: number): string[] {
  return iglooStages215.filter((item)=>item.stage<=stage&&item.featureId).map((item)=>String(item.featureId));
}

export function normalizeIglooProgress215(input: Partial<IglooProgress215> | undefined, fallbackTotalBricks = 0, updatedAt = new Date().toISOString()): IglooProgress215 {
  const sourceWallet=input?.brickWallet;
  const wallet:IglooBrickWallet215={
    ice:Math.max(0,Number(sourceWallet?.ice ?? input?.totalBricks ?? fallbackTotalBricks) || 0),
    family:Math.max(0,Number(sourceWallet?.family ?? 0) || 0),
    knowledge:Math.max(0,Number(sourceWallet?.knowledge ?? 0) || 0),
    sharing:Math.max(0,Number(sourceWallet?.sharing ?? 0) || 0),
    challenge:Math.max(0,Number(sourceWallet?.challenge ?? 0) || 0),
  };
  const legacyTotal=Math.max(0,Number(input?.totalBricks ?? 0)||0,Number(fallbackTotalBricks)||0);
  const walletTotal=brickWalletTotal215(wallet);
  if (walletTotal<legacyTotal) wallet.ice+=legacyTotal-walletTotal;
  const totalBricks=brickWalletTotal215(wallet);
  const currentStage=iglooStageForBricks(totalBricks);
  return {
    currentStage, totalBricks, nextRequirement:nextIglooRequirement(currentStage),
    completedStages:Array.from({length:currentStage},(_,index)=>index+1),
    unlockedFeatureIds:unlockedFeaturesForStage215(currentStage), brickWallet:wallet,
    updatedAt:input?.updatedAt ?? updatedAt,
  };
}

export function addIglooBricks215(progress: IglooProgress215, type: IglooBrickType215, amount: number, updatedAt = new Date().toISOString()): IglooProgress215 {
  const normalized=normalizeIglooProgress215(progress,progress.totalBricks,updatedAt);
  if (!Number.isFinite(amount) || amount<=0) return normalized;
  return normalizeIglooProgress215({ ...normalized, brickWallet:{ ...normalized.brickWallet, [type]:normalized.brickWallet[type]+Math.floor(amount) }, updatedAt },normalized.totalBricks,updatedAt);
}

export function iglooRate215(progress: IglooProgress215): number {
  return Math.min(100,Math.round((normalizeIglooProgress215(progress).totalBricks/iglooStages215.at(-1)!.requirement)*100));
}

export function iglooZoneForStage215(stage: number) {
  const item=iglooStages215[Math.min(35,Math.max(0,stage-1))];
  return iglooZones215.find((zone)=>zone.id===item.zoneId) ?? iglooZones215[0];
}
